import { cn } from '../utils/classes';
import type { AvatarProps } from './Avatar.web.types';
import { AvatarSizeClasses } from './AvatarSizeClasses';

export const Avatar = ({
  icon,
  imgURL,
  text,
  size = 'md',
  variant = 'circle',
  highlighted = false,
  className,
}: AvatarProps) => {
  const { root, fontSize, iconSize } = AvatarSizeClasses({ size });

  const displayImage = !!imgURL;
  const displayIcon = !imgURL && !!icon;
  const displayFallback = !imgURL && !icon;

  return (
    <div
      className={cn('flex justify-center overflow-hidden text-center bg-gray-200', root, className, {
        rounded: variant === 'rounded',
        'rounded-full': variant === 'circle',
        'ring-2 ring-white': highlighted,
      })}
    >
      {displayImage && <img className="inline-block h-full w-full object-cover" src={imgURL} alt={text} />}
      {displayIcon && <div className={cn('inline-flex justify-center items-center self-center', iconSize)}>{icon}</div>}
      {displayFallback && (
        <span
          className={cn('inline-flex items-center justify-center font-medium leading-none text-gray-500', fontSize)}
        >
          {text.slice(0, 3).toUpperCase()}
        </span>
      )}
    </div>
  );
};
